import theme from '@src/theme/theme';
import { RedeemStatus } from '@src/types/bonds/nftRedemption.types';

import { BondsAction } from '@dto/bonds/bonds.dto';

// DOM id of the Mint section; used for hash-scroll (#mint) from EmptyState/Hero.
export const MINT_BONDS_ANCHOR_ID = 'mint';

export const BONDS_REDEEM_DISCOUNT = 0.9;

export const BONDS_REDEEM_DESCRIPTION =
  `Redeem bonds at any time for ${BONDS_REDEEM_DISCOUNT * 100}% of the Bond's value. ` +
  'Select one or multiple bonds at a time. Requests are processed within two business days';

export const BONDS_STAKE_DESCRIPTION =
  'Stake bonds to start earning USDC rewards. You can unstake at any time.';
export const BONDS_UNSTAKE_DESCRIPTION =
  'Unstake to return bonds to your wallet. Rewards stop accruing — you can still redeem matured bonds anytime.';

export const RedeemStatusTitle: Record<RedeemStatus, string> = {
  [RedeemStatus.Pending]: 'Pending',
  [RedeemStatus.Accepted]: 'Accepted',
  [RedeemStatus.Canceled]: 'Canceled',
};

export const RedeemStatusColor = {
  [RedeemStatus.Pending]: theme.palette.custom.tags.processing,
  [RedeemStatus.Accepted]: theme.palette.custom.tags.success,
  [RedeemStatus.Canceled]: theme.palette.custom.tags.reject,
};

// Pending sits on a light pastel bg (dark text); Accepted/Canceled on saturated
// green/red (light text). Per Figma table node 19977:5400.
export const RedeemStatusTextColor = {
  [RedeemStatus.Pending]: theme.palette.custom.text.dark,
  [RedeemStatus.Accepted]: theme.palette.custom.text.light,
  [RedeemStatus.Canceled]: theme.palette.custom.text.light,
};

export const BondsActionTitle: Record<BondsAction, string> = {
  [BondsAction.Mint]: 'Minted',
  [BondsAction.Transfer]: 'Transferred',
};

export const BondsActionColor = {
  [BondsAction.Mint]: theme.palette.custom.tags.mint,
  [BondsAction.Transfer]: theme.palette.custom.tags.transfer,
};

export const DEBANK_LINK = 'https://debank.com/profile';
export const DOCUMENTATION_LINK =
  'https://bernard-bonds.gitbook.io/bernard-bonds';

export const AFFILIATE_ADDRESS = '0xe5Df13942C23A0fA89909fB40086429cCb40ac22';
export const AFFILIATE_CODE = 'BERNARD';

export const FAQ = [
  {
    title:
      'Is the price of an NFT simply tied to ETH, or does it reflect the actual value of the underlying treasury?',
    value:
      "The NFTs are not just tied to the price of ETH—they directly represent a proportional share of the actual fund. Each NFT reflects a real stake in the treasury, with its value determined by a simple formula: the total value of the fund (in USDC) divided by the number of NFTs in circulation. In essence, you're buying a percentage of the fund itself, not just speculating on ETH.",
  },
  {
    title:
      'Does the APR on bonds decrease as more people buy in? Does a larger vault size lead to a lower APR? Or is the rate primarily influenced by market performance?',
    value:
      'New capital deposits only dilute the APR temporarily—specifically until the end of the weekly epoch, when rewards generated by the new capital are added to the farm. You can track this in real time by watching the USDC balance accumulate in the fund’s wallet.\n' +
      'As the fund grows, new deposits have a smaller relative impact, making APR fluctuations less dramatic over time. It’s also worth noting that a drop in APR can actually signal positive performance: when NFT values rise, your principal is appreciating, so even a lower APR may still reflect net gains.',
  },
  {
    title: 'Where does the 10% exit tax go?',
    value:
      'A 10% sales tax is applied to bond redemptions and retained within the fund, while the redeemed NFTs are permanently burned. This mechanism reduces supply and redistributes value, increasing the worth of all remaining NFTs.\n',
  },
];
